import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { RemoveDocumentButton, StatusBadge, UploadedDocumentTile } from '../PurchaseV2.styles';
import pdfUploaded from '../../../assets/redesign_icons/file.svg';
import { Uploader } from '../../../common/components/redesignComponents/Uploader/Uploader';
import { uploadDocument } from '../../../services/axios-client/axeCommons';
import { sonnerSuccessAlert } from '../../../common/utils/sonnerAlerts';

function NonSignableDocumentComponent({
  insuranceRequest, documentType, downloadDocument, removeDocument, rc_quotation, collectQuoteData,
}) {
  const updloadDocument = (file) => {
    let fileInfo;
    let baseURL = '';
    const uploadedFile = file;
    // Make new FileReader
    const reader = new FileReader();
    // Convert the file to base64 text
    reader.readAsDataURL(uploadedFile);
    // on reader load pdf...
    reader.onload = async () => {
      fileInfo = uploadedFile.name;

      const fileType = uploadedFile.type;
      baseURL = reader.result;
      const data = {
        document_type_id: documentType.id,
        request_id: insuranceRequest.id,
        quotation_id: rc_quotation.id,
        original_filename: fileInfo,
        unsigned_document: baseURL.replace(`data:${fileType};base64,`, ''),
      };
      const response = await uploadDocument(data);
      if (response.status !== 200) {
        return;
      }
      collectQuoteData();
      sonnerSuccessAlert('File caricato');
    };
  };

  return (
    <>
      {(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id) !== undefined) ? (
        <UploadedDocumentTile>
          {(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id) && insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === 1) && (
            <StatusBadge tone="valid" background="#99DBB9" color="#009232">
              Valido
            </StatusBadge>
          )}
          {(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id) && insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === 0)
            && (
              <>
                <RemoveDocumentButton onClick={() => removeDocument(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).id)}>
                  <FontAwesomeIcon icon={faTimesCircle} color="red" />
                </RemoveDocumentButton>
                <StatusBadge tone="invalid" background="#FFB4B4" color="#F00">
                  Non Valido
                </StatusBadge>
              </>
            )}
          {(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id) && insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === null) && (
            <StatusBadge tone="pending" background="#009232" color="#ffffff">
              In verifica
            </StatusBadge>
          )}
          <img src={pdfUploaded} alt="" width={50} />
          {(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id) && insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).motivation !== null)
            && (
              <p className="text-danger">
                {insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).motivation}
              </p>
            )}
          <p onClick={() => downloadDocument(insuranceRequest.documents.find((doc) => doc.document_type_id === documentType.id).id)}>
            Tocca qui per scaricare
          </p>
          <h3>
            {documentType.name.toUpperCase()}
          </h3>
        </UploadedDocumentTile>
      ) : (rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id) !== undefined) ? (
        <UploadedDocumentTile>
          {(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id) && rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === 1) && (
            <StatusBadge tone="valid" background="#99DBB9" color="#009232">
              Valido
            </StatusBadge>
          )}
          {(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id) && rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === 0)
            && (
              <>
                <RemoveDocumentButton onClick={() => removeDocument(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).id)}>
                  <FontAwesomeIcon icon={faTimesCircle} color="red" />
                </RemoveDocumentButton>
                <StatusBadge tone="invalid" background="#FFB4B4" color="#F00">
                  Non Valido
                </StatusBadge>
              </>
            )}
          {(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id) && rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).is_uploaded_valid === null) && (
            <StatusBadge tone="pending" background="#009232" color="#ffffff">
              In verifica
            </StatusBadge>
          )}
          <img src={pdfUploaded} alt="" width={50} />
          {(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id) && rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).motivation !== null)
            && (
              <p className="text-danger">
                {rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).motivation}
              </p>
            )}
          <p onClick={() => downloadDocument(rc_quotation.documents.find((doc) => doc.document_type_id === documentType.id).id)}>
            Tocca qui per scaricare
          </p>
          <h3>
            {documentType.name.toUpperCase()}
          </h3>
        </UploadedDocumentTile>
      ) : <Uploader v2 onFileUpload={(file) => updloadDocument(file)} note={`CARICA ${documentType.name.toUpperCase()}`} />}
    </>
  );
}

export default NonSignableDocumentComponent;
